const ANY = "Any";

function unique(list) {
  return Array.from(new Set(list)).sort();
}

function FilterSelect({ label, value, setValue, options }) {
  return (
    <div>
      <label className="text-xs uppercase tracking-wider text-muted-foreground">{label}</label>
      <select
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
          console.log(`${label} changed to:`, e.target.value);
        }}
        className="mt-1 w-full rounded-lg border border-input bg-background px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-ring/40"
      >
        <option value={ANY}>Any</option>
        {options.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
    </div>
  );
}

function DonorSearch({ 
  query, 
  setQuery, 
  ethnicity, 
  setEthnicity, 
  eye, 
  setEye, 
  hair, 
  setHair, 
  education, 
  setEducation, 
  blood, 
  setBlood, 
  minHeight, 
  setMinHeight, 
  resetAll,
  options 
}) {
  return (
    <aside className="lg:sticky lg:top-20 lg:self-start rounded-2xl border border-border bg-card p-5 space-y-5">
      <div>
        <label className="text-xs uppercase tracking-wider text-muted-foreground">Search</label>
        <input
          value={query}
          onChange={(e) => {
            setQuery(e.target.value);
            console.log('Search query:', e.target.value);
          }}
          placeholder="Occupation, interest, code…"
          className="mt-1 w-full rounded-lg border border-input bg-background px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-ring/40"
        />
      </div>

      <FilterSelect label="Ethnicity" value={ethnicity} setValue={setEthnicity} options={options.ethnicity} />
      <FilterSelect label="Eye color" value={eye} setValue={setEye} options={options.eye} />
      <FilterSelect label="Hair color" value={hair} setValue={setHair} options={options.hair} />
      <FilterSelect label="Education" value={education} setValue={setEducation} options={options.education} />
      <FilterSelect label="Blood type" value={blood} setValue={setBlood} options={options.blood} />

      <div>
        <label className="text-xs uppercase tracking-wider text-muted-foreground flex justify-between">
          <span>Min height</span><span>{minHeight} cm</span>
        </label>
        <input
          type="range" min={160} max={195} value={minHeight}
          onChange={(e) => {
            setMinHeight(Number(e.target.value));
            console.log('Min height:', e.target.value);
          }}
          className="mt-2 w-full accent-[#3b82f6]"
        />
      </div>

      <button onClick={resetAll} className="w-full rounded-lg border border-border px-3 py-2 text-sm hover:bg-secondary transition">
        Reset filters
      </button>
    </aside>
  );
}

export default DonorSearch;
